import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { SupportProgressDialogComponent } from '../support-progress-dialog/support-progress-dialog.component';

@Component({
  selector: 'app-account-support-modal',
  templateUrl: './account-support-modal.component.html',
  styleUrls: ['./account-support-modal.component.scss'],
})
export class AccountSupportModalComponent {
  constructor(
    private dialogRef: MatDialogRef<AccountSupportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {}

  close(r: any = null) {
    this.dialogRef.close(r);
  }

  status(txt: string) {
    const m: any = {
      submitted: '已提交',
      processing: '处理中',
      waiting_confirmation: '待确认',
      done: '已完成',
    };
    return m[txt] || null;
  }

  checkFormDetail(id: number) {
    this.dialog.open(SupportProgressDialogComponent, {
      data: id,
      width: '665px',
      panelClass: 'app-dialog',
    });
  }
}
